import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import multi from 'redux-multi'

applyMiddleware(multi)(createStore)

import reducers from './reducers/reducer.js'
import Default from './data/_Default.js';

import App from './App';
import './css/index.css';

const store = createStore(reducers, Default);

// console.log('Default State', store.getState())

const render = () => {
	ReactDOM.render(
	  <Provider store={store}>
		  <App />
	  </Provider>,
	  document.getElementById('root')
  )
};

render();
store.subscribe(render);


// WEBPACK FOOTER //
// ./src/index.js